<footer class="inner_f_i" id="footer">
    <div class="container">
        <div class="row mt-5 fpad100">
            <div class="col-md-3 footer-nav">
                <label>{{'company' | translate}}</label>
                <ul>
                    <li><a href="javascript:;" routerLink="/aboutus">{{'aboutUs.title' | translate}}</a></li>
                    <li><a href="javascript:;">{{'news' | translate}}</a></li>
                </ul>
            </div>
            <div class="col-md-3 footer-nav">
                <label>{{'support' | translate}}</label>
                <ul>
                    <li><a href="javascript:;" routerLink="/contactus">{{'contactUs' | translate}}</a></li>
                    <li><a href="javascript:;" routerLink="/faq">{{'faqs.title' | translate}}</a></li>
                </ul>
            </div>
            <div class="col-md-3 footer-nav">
                <label>{{'legal' | translate}}</label>
                <ul>
                    <li><a href="javascript:;" routerLink="/terms">{{'termsOfUse' | translate}}</a></li>
                    <li><a href="javascript:;" routerLink="/policy">{{'privacyPolicy.title' | translate}}</a></li>
                </ul>
            </div>
            <div class="col-md-3 footer-social">
                <img class="f-logo" src="/assets/img/logo.png" />
                <ul>
                    <li><a><img src="/assets/img/Icon/facebook.svg" /></a></li>
                    <li><a><img src="/assets/img/Icon/instagram.svg" /></a></li>
                    <li><a><img src="/assets/img/Icon/linkedin.svg" /></a></li>
                    <li><a><img src="/assets/img/Icon/youtube.svg" /></a></li>
                </ul>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12 footer-bottom">
                <h6 class="text-white text-center">{{'availableOnManyDevicesInstallNow' | translate}}</h6>
                <ul class="footer-brand">
                    <li><a target="_blank" href="https://play.google.com/store/games?hl=en"><img src="/assets/img/Icon/google-play.svg" /></a></li>
                    <li><a target="_blank" href="https://www.apple.com/in/app-store/"><img src="/assets/img/Icon/app-store.svg" /></a></li>
                    <li><a target="_blank" href="https://play.google.com/store/games?hl=en"><img src="/assets/img/Icon/android-tv.svg" /></a></li>
                    <li><a target="_blank" href="https://www.amazon.com/Fire-TV-Apps-All-Models/b?ie=UTF8&node=10208590011"><img src="/assets/img/Icon/fire-tv.svg" /></a></li>
                    <li><a target="_blank" href="https://www.samsung.com/us/tvs/smart-tv/samsung-tv-apps/"><img src="/assets/img/Icon/samsung_smart_tv.svg" /></a></li>
                    <li><a target="_blank" href="https://www.apple.com/in/app-store/"><img src="/assets/img/Icon/apple_tv.svg" /></a></li>
                    <li><a target="_blank" href="https://in.lgappstv.com/main"><img src="/assets/img/Icon/lg_smart_tv.svg" /></a></li>
                    <li><a target="_blank" href="https://channelstore.roku.com/browse/apps"><img src="/assets/img/Icon/roku.svg" /></a></li>
                </ul>
                <p>&copy; {{currentYear}}, {{'ottRunByDigiviveAllRightsReserved' | translate}}</p>
            </div>
        </div>         
    </div>        
</footer>